<template>
  <section class="table">
    <template v-if="!csHome">
      <el-table
        :data="tableData"
        :show-header="showHeader"
        style="width: 100%"
        :row-class-name="'table-pointer'"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="69px"
          align="center">
          <template #default="{ row }">
            <div class="flex-column  flex-align-center">
              <span
                v-if="row.merchant_platform"
                class="table-icon__img mg-b-8">
                <img :src="getOptionName('serverTypeIcon',row.merchant_platform)" >
              </span>
              <font-awesome-icon
                icon="file-powerpoint"
                class="icon-color fs-16"
                :class="{
                  'gray': row.effectiveness == 1,
                  'green': row.effectiveness == 2,
                  'red': row.effectiveness == 3
                }"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="95px"
          prop="created_at"
          label="Updated">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <span>{{ row.created_at.split(" ")[0] }}</span><br>
              <span> {{ row.created_at.split(" ")[1] }}</span>
            </div>
            <div class="flex-algin">
              <span>
                <div class="flex  table-icon">
                  <div v-if="row.company_id">
                    <span
                      v-tooltip="row.company_language"
                      class="icon icon-content"
                    >
                      <img
                        :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                      >
                    </span>
                  </div>
                  <div>
                    <span
                      v-tooltip="row.class_language"
                      class="icon icon-content"
                    >
                      <font-awesome-icon
                        v-if="row.class_id&& row.product_id!==80"
                        :icon="getOptionName('iconOptions', row.class_id)" />
                      <font-awesome-icon
                        v-else
                        icon="cube" />
                    </span>
                  </div>
                </div>
                <div class="flex table-icon margin-top-flex">
                  <div>
                    <span
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(2)) && extra_show(row.extra_benefits_content,2)==2"
                      v-tooltip="extra_tip(row.extra_benefits_content,2)"
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="wind" />
                    </span>
                  </div>
                  <div>
                    <span
                      v-if="Array.isArray(row.extra_benefits) && row.extra_benefits.includes(1) && extra_show(row.extra_benefits_content,1)==1"
                      v-tooltip="extra_tip(row.extra_benefits_content,1)"
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="user-injured" />
                    </span>
                  </div>
                  <div>
                    <span
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(4)) && extra_show(row.extra_benefits_content,4)==4"
                      v-tooltip="extra_tip(row.extra_benefits_content,4)"
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="key" />
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Plan Name">
          <template #default="{ row }">
            <span class="span-label">
              <router-link
                class="showLink"
                :to="rowClickFn(row)">
                {{ row.insurer }} {{ row.class_id>50?row.product_type:row.plan}}
              </router-link>
            </span>
            <p
              v-if="row.pcy_no||row.cvr_nt_no"
              class="phone-text">
              <span  v-if="row.pcy_no"><span class="weight-text">Policy No. </span> {{ row.pcy_no }}&nbsp;&nbsp;&nbsp;</span>
              <span  v-if="row.cvr_nt_no"><span class="weight-text">CN# </span> {{ row.cvr_nt_no }}</span>
            </p>
            <span
              v-if="row.order_sn"
              class="phone-text">
              <template><span class="weight-text"> Ref. </span>{{ row.order_sn }}</template>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Summary">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text summary">{{ row.description }} </p>
              <span v-if="row.rgtn_no">
                <span class="summary_rgtn_no">{{ row.rgtn_no }} </span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Policyholder">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.policy_holder }}</span>
              <span>
                <template v-if="row.identity == 2">
                  {{ row.contact_nm }}
                </template>
                <span class="phone-text"> {{ row.phone_no }}</span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="referrer_nm"
          width="95"
          label="Referrer">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text">
                <span
                  v-if="row.referrer_id != 0 && row.referrer_nm.trim() === ''"
                  class="unname">Unnamed</span>
                <span v-if="row.referrer_id != 0">{{ row.referrer_nm }}</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="95"
          prop=""
        >
          <template  #header="{column, $index}">
            <span
              class="pointer"
              @click="handleSort(2)">
              <span >Period</span>
              <font-awesome-icon
                v-if="sort==2"
                class="mg-l-8"
                icon="arrow-down"></font-awesome-icon>
            </span>
          </template>
          <template #default="{ row }">
            <div class="flex-algin period-text">
              <span>{{ row.policy_period.split(" - ")[0] }}&nbsp;-</span>
              <span> {{ row.policy_period.split(" - ")[1] }}</span>
              <span
                v-if="row.is_eff_dt_delay && row.stts != 425"
                class="asap">ASAP</span>
            </div>
          </template>

        </el-table-column>
        <el-table-column
          width="155px"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="status-height">
                <span
                  class="span-status"
                  :class="{
                    'red': [801, 0].includes(row.stts),
                    'orange': [401, 301].includes(row.stts),
                    'yellow-dark': [410, 501, 701].includes(row.stts),
                    'blue': [420, 505, 705].includes(row.stts),
                    'green': [425, 510, 710].includes(row.stts)
                  }">
                  {{ row.stts_language }}
                </span>
              </p>
              <p
                v-for="(v,i) in row.tag_language"
                :key="i"
                class="status-height">
                <span
                  class="span-options"
                  :class="{
                    'gold': v.id == 1,
                    'blue': [2,16,64,256].includes(v.id),
                    'orange': v.id == 4,
                    'black': [8,32,128].includes(v.id),
                    'red': [512].includes(v.id),
                    'gray': [1024, 2048].includes(v.id)
                  }">{{v.name}}</span>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template v-else>
      <el-table
        :data="tableData"
        :show-header="showHeader"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="69px"
          align="center">
          <template #default="{ row }">
            <div class="flex-column  flex-align-center">
              <span
                v-if="row.merchant_platform"
                class="table-icon__img mg-b-8">
                <img :src="getOptionName('serverTypeIcon',row.merchant_platform)" >
              </span>
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="file-powerpoint"
                  class="icon-color fs-16"
                  :class="{
                    'gray': row.effectiveness == 1,
                    'green': row.effectiveness == 2,
                    'red': row.effectiveness == 3
                  }"/>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="95px"
          label="Created">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.created_at.split(" ")[0] }}</span><br>
              <span> {{ row.created_at.split(" ")[1] }}</span>
              <!--              </span>-->
            </div>
            <p class="channel">{{row.source_language}}</p>
          </template>

        </el-table-column>
        <el-table-column
          width="70"
          prop="id"
        >
          <template #default="{ row }">
            <!--            <span class="button-border">{{row.type_language}}</span>-->
            <div
              class="flex-algin">
              <span>
                <div class="flex  table-icon">
                  <div v-if="row.company_id">
                    <span
                      v-tooltip="row.company_language"
                      class="icon icon-content"
                    >
                      <img
                        :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                      >
                    </span>
                  </div>
                  <div>
                    <span
                      v-tooltip="row.class_language"
                      class="icon icon-content"
                    >
                      <font-awesome-icon
                        v-if="row.class_id&& row.product_id!==80"
                        :icon="getOptionName('iconOptions', row.class_id)" />
                      <font-awesome-icon
                        v-else
                        icon="cube" />
                    </span>
                  </div>
                </div>
                <div
                  v-if="row.product_id!==80"
                  class="flex table-icon margin-top-flex">
                  <div>
                    <span
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(2)) && extra_show(row.extra_benefits_content,2)==2"
                      v-tooltip="extra_tip(row.extra_benefits_content,2)"
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="wind" />
                    </span>
                  </div>
                  <div>
                    <span
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(1)) && extra_show(row.extra_benefits_content,1)==1"
                      v-tooltip="extra_tip(row.extra_benefits_content,1)"
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="user-injured" />
                    </span>
                  </div>
                  <div>
                    <span
                      v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(4)) && extra_show(row.extra_benefits_content,4)==4"
                      v-tooltip="extra_tip(row.extra_benefits_content,4)"
                      class="icon icon-content backgroud-width"
                    >
                      <font-awesome-icon
                        icon="key" />
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Policy">
          <template #default="{ row }">
            <span class="span-label">
              <router-link
                class="showLink"
                :to="rowClickFn(row)">
                {{ row.insurer }} {{ row.class_id>50?row.product_type:row.plan}}
              </router-link>
            </span>
            <p
              v-if="row.pcy_no||row.cvr_nt_no"
              class="phone-text">
              <span  v-if="row.pcy_no"><span class="weight-text">Policy No. </span> {{ row.pcy_no }}&nbsp;&nbsp;&nbsp;</span>
              <span  v-if="row.cvr_nt_no"><span class="weight-text">CN# </span> {{ row.cvr_nt_no }}</span>
            </p>
            <span
              v-if="row.order_sn"
              class="phone-text">
              <template><span class="weight-text"> Ref. </span>{{ row.order_sn }}</template>
            </span>
          </template>
        </el-table-column>

        <el-table-column
          width="105px"
          label="Summary">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text summary">{{ row.description }} </p>
              <span v-if="row.rgtn_no">
                <span class="summary_rgtn_no">{{ row.rgtn_no }} </span>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="105px"
          label="Policyholder">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.policy_holder }}</span>
              <span>
                <template v-if="row.identity == 2">
                  {{ row.contact_nm }}
                </template>
                <span class="phone-text"> {{ row.phone_no }}</span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="89px"
          :show-overflow-tooltip="true"
          label="Referrer"
          prop="referrer_nm">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text">
                <span
                  v-if="row.referrer_id != 0 && row.referrer_nm.trim() === ''"
                  class="unname">Unnamed</span>
                <span v-if="row.referrer_id != 0">{{ row.referrer_nm }}</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="110"
          prop=""
          label="Period">
          <template #default="{ row }">
            <div class="flex-algin period-text">
              <span>{{ row.policy_period.split(" - ")[0] }}&nbsp;-</span>
              <span> {{ row.policy_period.split(" - ")[1] }}</span>
              <span
                v-if="row.is_eff_dt_delay"
                class="asap">ASAP</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="155px"
          label="Status">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="status-height">
                <span
                  class="span-status"
                  :class="{
                    'red': [801, 0].includes(row.stts),
                    'orange': [401, 301].includes(row.stts),
                    'yellow-dark': [410, 501, 701].includes(row.stts),
                    'blue': [420, 505, 705].includes(row.stts),
                    'green': [425, 510, 710].includes(row.stts)
                  }">
                  {{ row.stts_language }}
                </span>
              </p>
              <p
                v-for="(v,i) in row.tag_language"
                :key="i"
                class="status-height">
                <span
                  class="span-options"
                  :class="{
                    'gold': v.id == 1,
                    'yellow-dark': [16384].includes(v.id),
                    'blue': [2,16,64,256].includes(v.id),
                    'orange': v.id == 4,
                    'black': [8,32,128].includes(v.id),
                    'red': [512].includes(v.id),
                    'gray': [1024].includes(v.id)
                  }">{{v.name}}</span>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <v-pagination
      v-if="showHeader"
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getAccountPolicyList} from '@/api/account'
import {getPolicyList} from '@/api/policy'
import {mapActions} from 'vuex'

export default {
  name: 'PoliciesTab',
  mixins: [MixinOptions],
  props: {
    showHeader:{
      type: Boolean,
      default: true,
    },
    customerId:{
      type: [String, Number],
      default: null
    },
    size: {
      type: Number,
      default: 20
    },
    filters: {
      type: Object,
      default: () => {}
    },
    csHome: {
      type: Boolean,
      default: false
    },
    isFina: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      tableData: [],
      sort:1
    }
  },
  computed: {
    extra_show(){
      return (row,index)=>{
        let textData = {}
        if(!row) return ''
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        return textData.id
      }
    },
    extra_tip(){
      return (row,index)=>{
        let textData = {}
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        if(textData)
          return textData.name

      }
    }
  },
  watch: {
    filters:{
      deep: true,
      handler(){
        this.pageConfig.currentPage = 1
        this.network().getPolicyList()
      }
    },
    customerId:{
      immediate: true,
      handler(val){
        if(val){
          this.pageConfig.currentPage = 1
          this.network().getPolicyList()
        }
      }
    },
    csHome:{
      immediate: true,
      handler(val){
        console.log(val)
        if(val){
          this.network().getPolicyList()
        }
      }
    },
    isFina:{
      immediate: true,
      handler(val){
        if(val){
          this.network().getPolicyList()
        }
      }
    }
  },
  methods: {
    ...mapActions('account', ['setCustomerFilter']),
    handleSort(type,cloumn,index){
      // this.sort = type
      // this.network().getPolicyList()
    },
    rowClick({ id, pcy_id, product_id = -1 }) {
      this.$router.push({
        path: product_id == 90? '/records/micropolicy/detail' : product_id > 50&&product_id<80? '/records/policy/manual/detail' :'/records/policy/detail',
        query: {
          id,
          product_id,
          pcy_id
        }
      })
      this.setCustomerFilter({
        policy: this.filters
      })
    },
    rowClickFn({id, product_id, pcy_id}){
      return({
        path: product_id == 90? '/records/micropolicy/detail' : product_id > 50&&product_id<80? '/records/policy/manual/detail' :'/records/policy/detail',
        query: {
          id,
          product_id,
          pcy_id
        }
      })
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getPolicyList()
    },
    network() {
      return {
        getPolicyList: async () => {
          if(this.csHome){
            var { data } = await getPolicyList({
              page: this.pageConfig.currentPage,
              size: this.size,
              ...this.filters,
            })
          }else{
            var { data } = await getAccountPolicyList({
              page: this.pageConfig.currentPage,
              customer_id: this.customerId,
              size: this.size,
              ...this.filters,
              // order_by_data:this.sort==1?'updated_at':'sort_time',
              // order_by_sort:'desc',
              merchant_platform:this.isFina?2:1
            })
          }
          this.tableData = data.data
          this.pageConfig.total = data.total
          this.$emit('update:policyNum', data.total)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.table {
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 500;
  }
  .span-status, .span-options {
    display: inline-block;
    //margin-right: 15px;
    padding: 1px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    //text-overflow: ellipsis;
    //width: 120px;
    max-width: 160px;
    word-break:keep-all;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
  }
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.yellow-dark {
      border-color: #DBAB09;
      color: #DBAB09;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  .icon-color{
    &.gray {
      color: #586069;
    }
    &.green {
      color: #22863A;
    }
    &.red {
      color: #D73A49;
    }
  }
  .flex-algin {
    &.time-text{
      font-size: 12px;
    }
    .first-text{
      color: #24292E;
      font-size: 14px;
    }
    .summary{
      font-size: 12px;
      word-break: break-word;
    }
    .summary_rgtn_no{
      color: #6A737D;
      font-size: 12px;
      border: 1px solid #6A737D;
      border-radius: 4px;
      padding: 2px 4px;
    }
    .channel{
      font-size: 12px;
      font-weight: 600;
      color: #586069;
      margin: 5px 0;
      height: 18px;
      line-height: 18px;
    }
    .status-height{
      height: 23px;
    }
  }
  .table-icon{
    &.margin-top-flex{
      margin-top: 5px;
    }
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
    .backgroud-width{
      background: #fff!important;
      border: 1px solid #e1e4e8;
    }
  }
  .weight-text{
    font-weight: 600;
  }
  .phone-text{
    font-size: 12px;
  }
  .showLink{
    text-decoration: none;
    font-weight: 600;
    color: #24292E;
    &:hover{
      color:  #0366D6;
    }
  }


  /deep/ .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    tr{
      td{
        padding: 10px 15px 10px 0!important;
        vertical-align: top;
        .cell{
          line-height: 23px;
          position: relative;
          height: inherit;
          padding: 0;
        }
      }
    }
    .table-pointer{
      cursor: pointer;
    }
  }

  /deep/ .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;

    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      padding: 10px 0!important;
      color: #24292E!important;
      .cell{
        padding-left: 0;
      }
    }
    .button-border{
      display: inline-block;
      padding: 0px 10px;
      height: auto;
      //line-height: 30px;
      font-size: 12px;
      border-radius: 50px;
      border: 1px solid #E1E4E8;
      color: #24292E;
      background: white;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;

    }
  }
}
.span-name {
  display: block;
  color: #24292E;
  height: auto!important;
  font-size: 14px;
  word-break: break-word;
}
</style>
